export enum HomeRouterNames {
  DASHBOARD = "dashboard",
  EMPLOYEES = "employees",
  ALL_CASES = "all_cases",
  REDUNDANCY_CALCULATOR = "redundancy-calculator",
  TASKS = "tasks",
  TIME_ATTENDANCE = "time-attendance",
  CALENDAR = "calendar",
  STORE_DETAILS = "store-details",
  REQUESTS = "requests",
  SCHEDULING = "scheduling",
  NOTIFICATION_LOGS = "notification-logs",
  CANDIDATES = "candidates",
  SYSTEM_USER = "system-user",
  SYSTEM_SETTING = "system-setting",
  UPCOMING_NOTIFICATIONS = "notification-logs/upcoming-notifications",
  // LONG_SERVICE_AWARD = 'long-service-award',
  // SETTINGS = 'settings',
}
